// Le scénario complet de "Elle. Elle est là." — un tableau de "beats" (répliques)
// lus séquentiellement par le moteur de récit dans App.vue.
//
// Types de beat (t) :
//   title      — titre d'ouverture
//   narration  — texte narratif standard
//   whisper    — réplique chuchotée
//   knock      — un "Toc." / "Clic." (jump-scare sonore + flash)
//   computer   — message tapé à l'écran façon terminal
//   screen     — prise de contrôle totale de l'écran par l'ordinateur (gros texte)
//   countdown  — chiffres du compte à rebours
//   phone      — notification de téléphone interactive (à toucher pour continuer)
//   reveal     — révélation d'image plein écran
//
// Champs optionnels :
//   panic: "start" | "end"  — délimite une fenêtre d'effets de panique (cœur, teinte rouge, tremblement)
//   calm: "start"           — délimite le début d'une fenêtre de calme/soulagement (son coupé, écran éclairci)
//   shock: true             — choc brutal : coupe le calme, gros flash, déclenche la panique
//   stop: true              — empêche l'avancée automatique ; il faut cliquer pour continuer

export default [
  { t: "title", x: "Elle.. Elle est là" },
  { t: "narration", x: "La première chose que j'ai remarquée, c'était le bruit." },
  { t: "narration", x: "Trois coups." },
  { t: "narration", x: "Pas forts." },
  { t: "narration", x: "Même pas assez forts pour réveiller quelqu'un qui dormait." },
  { t: "narration", x: "Juste..." },
  { t: "knock", x: "Toc." },
  { t: "narration", x: "Une pause." },
  { t: "knock", x: "Toc." },
  { t: "narration", x: "Une pause plus longue." },
  { t: "knock", x: "Toc." },
  { t: "narration", x: "J'ouvris les yeux." },
  { t: "narration", x: "La pièce était plongée dans le noir." },
  { t: "narration", x: "Mon ordinateur était toujours allumé, alors que j'étais certain de l'avoir éteint avant d'aller me coucher." },
  { t: "narration", x: "L'écran affichait une seule ligne de texte blanc." },
  { t: "screen", x: "ELLE.. ELLE EST LÀ" },
  { t: "narration", x: "Je fixai l'écran." },
  { t: "narration", x: "Je pensais que c'était une sorte d'erreur." },
  { t: "narration", x: "Puis je remarquai le curseur." },
  { t: "narration", x: "Il clignotait." },
  { t: "narration", x: "Il attendait." },
  { t: "narration", x: "Je bougeai la souris." },
  { t: "narration", x: "Rien." },
  { t: "narration", x: "J'appuyai sur une touche." },
  { t: "narration", x: "Rien." },
  { t: "narration", x: "Puis, lentement, une nouvelle phrase apparut." },
  { t: "screen", x: "NE REGARDE PAS LA PORTE." },
  { t: "narration", x: "Je cessai de respirer." },
  { t: "narration", x: "Les trois coups retentirent à nouveau." },
  { t: "knock", x: "Toc." },
  { t: "knock", x: "Toc." },
  { t: "knock", x: "Toc." },
  { t: "narration", x: "Cette fois, ils étaient plus forts." },
  { t: "narration", x: "Je regardai vers la porte de la chambre." },
  { t: "narration", x: "Elle était fermée." },
  { t: "narration", x: "J'en étais certain." },
  { t: "narration", x: "Je l'avais fermée." },
  { t: "narration", x: "Mais quelque chose se trouvait sous la porte." },
  { t: "narration", x: "Une ombre." },
  { t: "narration", x: "Quelqu'un se tenait de l'autre côté." },
  { t: "narration", x: "Je me figeai." },
  { t: "narration", x: "L'ordinateur afficha une nouvelle phrase." },
  { t: "screen", x: "J'AI DIT DE NE PAS REGARDER." },
  { t: "narration", x: "Mon cœur se mit à battre si fort que je pouvais le sentir dans ma gorge." },
  { t: "narration", x: "J'essayai de me convaincre que quelqu'un était entré dans la maison." },
  { t: "narration", x: "Ce serait logique." },
  { t: "narration", x: "Un cambrioleur." },
  { t: "narration", x: "Un voisin." },
  { t: "narration", x: "N'importe quoi." },
  { t: "narration", x: "Tout était préférable à ce que mon esprit commençait à imaginer." },
  { t: "narration", x: "Puis l'ordinateur écrivit :" },
  { t: "screen", x: "ELLE PEUT ENTENDRE TES PENSÉES." },
  { t: "narration", x: "J'eus presque envie de rire." },
  { t: "narration", x: "Presque." },
  { t: "narration", x: "Parce que c'était absurde." },
  { t: "narration", x: "Ça devait l'être." },
  { t: "narration", x: "Je saisis mon téléphone." },
  { t: "narration", x: "Aucun réseau." },
  { t: "narration", x: "J'ouvris le clavier pour appeler les urgences." },
  { t: "narration", x: "L'écran devint noir." },
  { t: "narration", x: "Puis mon téléphone vibra." },
  { t: "narration", x: "Une notification apparut." },
  { t: "phone", x: "1 nouvelle photo." },
  { t: "narration", x: "Je n'avais rien reçu." },
  { t: "narration", x: "Il n'y avait aucun expéditeur." },
  { t: "narration", x: "Juste une photo de profil vide." },
  { t: "narration", x: "C'était une photographie de ma chambre." },
  { t: "narration", x: "Prise depuis le coin du plafond." },
  { t: "narration", x: "Dans le coin de l'image, un horodatage clignotait : 14/03/2003." },
  { t: "narration", x: "Je pouvais me voir assis sur le lit." },
  { t: "narration", x: "Je pouvais voir l'ordinateur." },
  { t: "narration", x: "Je pouvais voir la porte fermée." },
  { t: "narration", x: "Et sous la porte..." },
  { t: "narration", x: "Cette ombre." },
  { t: "narration", x: "Je levai les yeux." },
  { t: "narration", x: "Le coin du plafond était vide." },
  { t: "narration", x: "Je regardai à nouveau la photographie." },
  { t: "narration", x: "Quelque chose avait changé." },
  { t: "narration", x: "Une femme se tenait derrière moi." },
  { t: "narration", x: "Grande." },
  { t: "narration", x: "Son visage était caché par de longs cheveux noirs." },
  { t: "narration", x: "Je me retournai." },
  { t: "narration", x: "Rien." },
  { t: "narration", x: "Je regardai à nouveau la photo." },
  { t: "reveal", x: "Elle était plus proche." },
  { t: "narration", x: "Je lâchai mon téléphone.", panic: "start" },
  { t: "narration", x: "L'écran se fissura contre le sol." },
  { t: "narration", x: "L'ordinateur afficha une nouvelle phrase." },
  { t: "screen", x: "NE TE RETOURNE PLUS." },
  { t: "narration", x: "Je ne le fis pas." },
  { t: "narration", x: "Je ne pouvais pas." },
  { t: "narration", x: "Je restai complètement immobile." },
  { t: "narration", x: "La pièce semblait être devenue beaucoup plus froide." },
  { t: "narration", x: "Puis j'entendis une respiration." },
  { t: "narration", x: "Pas la mienne." },
  { t: "narration", x: "Lente." },
  { t: "narration", x: "Silencieuse." },
  { t: "narration", x: "Juste derrière moi." },
  { t: "narration", x: "Je fermai les yeux." },
  { t: "narration", x: "L'ordinateur commença à écrire." },
  { t: "narration", x: "Une lettre après l'autre." },
  { t: "screen", x: "ELLE ATTENDAIT QUE TU REMARQUES SA PRÉSENCE." },
  { t: "narration", x: "La respiration s'arrêta." },
  { t: "narration", x: "J'attendis." },
  { t: "narration", x: "Cinq secondes." },
  { t: "narration", x: "Dix." },
  { t: "narration", x: "Rien." },
  { t: "narration", x: "Puis j'entendis un murmure." },
  { t: "narration", x: "Tout près de mon oreille." },
  { t: "whisper", x: "« Enfin. »" },
  { t: "narration", x: "Je hurlai." },
  { t: "narration", x: "Je me retournai." },
  { t: "narration", x: "Il n'y avait personne.", panic: "end" },
  { t: "narration", x: "La porte de la chambre était toujours fermée." },
  { t: "narration", x: "Mais l'ombre sous la porte avait disparu." },
  { t: "narration", x: "Je regardai l'ordinateur." },
  { t: "narration", x: "L'écran était noir." },
  { t: "narration", x: "Puis il se ralluma." },
  { t: "narration", x: "Un seul mot apparut." },
  { t: "screen", x: "COURS.", panic: "start" },
  { t: "narration", x: "Je sautai du lit et attrapai la poignée de la porte." },
  { t: "narration", x: "Elle ne bougea pas." },
  { t: "narration", x: "Verrouillée." },
  { t: "narration", x: "Je tirai plus fort." },
  { t: "narration", x: "Rien." },
  { t: "narration", x: "Derrière moi, l'ordinateur émit un son de notification." },
  { t: "narration", x: "Je me retournai." },
  { t: "narration", x: "Un nouveau message." },
  { t: "screen", x: "ELLE N'EST PAS DANS LA PIÈCE." },
  { t: "narration", x: "Je ressentis un étrange soulagement." },
  { t: "narration", x: "Jusqu'à ce que la ligne suivante apparaisse." },
  { t: "screen", x: "ELLE EST DANS LE SITE." },
  { t: "narration", x: "Mon sang se glaça." },
  { t: "narration", x: "Le curseur se déplaça tout seul." },
  { t: "narration", x: "Une fenêtre de navigateur s'ouvrit." },
  { t: "narration", x: "Il n'y avait aucune adresse." },
  { t: "narration", x: "Aucun logo." },
  { t: "narration", x: "Aucun bouton." },
  { t: "narration", x: "Juste une page noire." },
  { t: "narration", x: "Et au milieu..." },
  { t: "narration", x: "Une vidéo en direct." },
  { t: "narration", x: "Ma chambre." },
  { t: "narration", x: "Je pouvais me voir debout devant la porte." },
  { t: "narration", x: "Mais la caméra n'était plus dans le coin du plafond." },
  { t: "narration", x: "Elle était derrière moi." },
  { t: "narration", x: "Je regardai lentement l'écran." },
  { t: "narration", x: "La femme était là." },
  { t: "narration", x: "Debout, juste derrière moi." },
  { t: "narration", x: "Je ne pouvais plus bouger." },
  { t: "narration", x: "Elle leva une main." },
  { t: "narration", x: "Et pointa la porte." },
  { t: "narration", x: "L'ordinateur écrivit :" },
  { t: "screen", x: "ELLE VEUT QUE TU L'OUVRES." },
  { t: "narration", x: "La poignée bougea." },
  { t: "narration", x: "Une seule fois." },
  { t: "knock", x: "Clic." },
  { t: "narration", x: "Je reculai." },
  { t: "narration", x: "La poignée bougea encore." },
  { t: "knock", x: "Clic." },
  { t: "narration", x: "Puis quelque chose apparut sur l'écran." },
  { t: "narration", x: "Un compteur." },
  { t: "countdown", x: "00:07:43" },
  { t: "narration", x: "En dessous :" },
  { t: "screen", x: "TEMPS RESTANT." },
  { t: "narration", x: "Je regardai les chiffres défiler." },
  { t: "countdown", x: "00:07:42" },
  { t: "countdown", x: "00:07:41" },
  { t: "narration", x: "Je ne comprenais pas." },
  { t: "narration", x: "Puis un nouveau message apparut." },
  { t: "screen", x: "TU AS DÉJÀ OUVERT CETTE PORTE 17 FOIS." },
  { t: "narration", x: "Je secouai la tête." },
  { t: "whisper", x: "« Non. »" },
  { t: "narration", x: "L'écran clignota." },
  { t: "narration", x: "Une photographie apparut." },
  { t: "narration", x: "Moi." },
  { t: "narration", x: "Debout dans l'encadrement de la porte." },
  { t: "narration", x: "Une autre photographie." },
  { t: "narration", x: "Moi." },
  { t: "narration", x: "Marchant dans le couloir." },
  { t: "narration", x: "Une autre." },
  { t: "narration", x: "Moi." },
  { t: "narration", x: "Debout devant ma propre chambre." },
  { t: "narration", x: "Il y en avait des dizaines." },
  { t: "narration", x: "Des centaines." },
  { t: "narration", x: "Toutes prises lors de nuits différentes." },
  { t: "narration", x: "Avec des vêtements différents." },
  { t: "narration", x: "Des coiffures différentes." },
  { t: "narration", x: "Mais toujours la même expression." },
  { t: "narration", x: "Terrifiée." },
  { t: "narration", x: "Je ne me souvenais d'aucune d'entre elles." },
  { t: "narration", x: "Au dos de l'une d'elles, une écriture presque effacée : LÉA." },
  { t: "narration", x: "La dernière photographie apparut." },
  { t: "narration", x: "Elle me montrait assis sur le lit." },
  { t: "narration", x: "Exactement comme maintenant." },
  { t: "narration", x: "Sauf que..." },
  { t: "narration", x: "Je n'étais pas seul." },
  { t: "narration", x: "La femme était assise à côté de moi." },
  { t: "narration", x: "Sa tête reposait sur mon épaule." },
  { t: "narration", x: "Et je souriais." },
  { t: "narration", x: "Je fixai la photographie." },
  { t: "narration", x: "Je ne souriais pas." },
  { t: "narration", x: "La femme sur la photo leva lentement la tête." },
  { t: "narration", x: "L'image changea." },
  { t: "narration", x: "Elle regardait directement la caméra." },
  { t: "narration", x: "Puis un nouveau message apparut." },
  { t: "screen", x: "ELLE SAIT QUE TU LA REGARDES." },
  { t: "narration", x: "Les lumières s'éteignirent." },
  { t: "narration", x: "Le noir complet." },
  { t: "narration", x: "J'entendis la porte s'ouvrir." },
  { t: "narration", x: "Lentement." },
  { t: "narration", x: "Un long grincement." },
  { t: "narration", x: "Je ne bougeai pas." },
  { t: "narration", x: "Je ne pouvais pas." },
  { t: "narration", x: "Quelque chose entra dans la pièce." },
  { t: "narration", x: "Des pieds nus sur le sol." },
  { t: "narration", x: "Un pas." },
  { t: "narration", x: "Puis un autre." },
  { t: "narration", x: "Plus près." },
  { t: "narration", x: "Encore plus près." },
  { t: "narration", x: "L'écran de l'ordinateur illumina la pièce." },
  { t: "narration", x: "Et pendant une fraction de seconde, je la vis." },
  { t: "narration", x: "Elle se tenait devant moi." },
  { t: "narration", x: "Ses cheveux lui couvraient le visage." },
  { t: "narration", x: "Ses bras pendaient étrangement bas." },
  { t: "narration", x: "Elle inclina la tête." },
  { t: "narration", x: "Puis elle murmura :" },
  { t: "whisper", x: "« Tu n'es pas censé t'en souvenir. »" },
  { t: "narration", x: "L'écran devint noir.", panic: "end" },
  { t: "narration", x: "Je me réveillai dans mon lit.", calm: "start" },
  { t: "narration", x: "La lumière du matin traversait la fenêtre." },
  { t: "narration", x: "Tout était normal." },
  { t: "narration", x: "L'ordinateur était éteint." },
  { t: "narration", x: "La porte de la chambre était ouverte." },
  { t: "narration", x: "Mon téléphone était sur le sol." },
  { t: "narration", x: "Je le ramassai." },
  { t: "narration", x: "Aucune notification." },
  { t: "narration", x: "Aucune photo." },
  { t: "narration", x: "Rien." },
  { t: "narration", x: "Je ris." },
  { t: "narration", x: "Ce n'était qu'un cauchemar." },
  { t: "narration", x: "Un stupide cauchemar, beaucoup trop réaliste." },
  { t: "narration", x: "Je m'habillai." },
  { t: "narration", x: "Je préparai un café." },
  { t: "narration", x: "Puis je m'assis devant l'ordinateur." },
  { t: "narration", x: "J'appuyai sur le bouton d'allumage." },
  { t: "narration", x: "L'écran s'alluma." },
  { t: "narration", x: "Pendant quelques secondes, rien ne se passa." },
  { t: "narration", x: "Puis un navigateur s'ouvrit." },
  { t: "narration", x: "Une page noire." },
  { t: "narration", x: "Du texte blanc." },
  { t: "screen", x: "BONJOUR.", shock: true },
  { t: "narration", x: "Je fixai l'écran." },
  { t: "narration", x: "Une autre ligne apparut." },
  { t: "screen", x: "AS-TU BIEN DORMI ?" },
  { t: "narration", x: "Je ne touchai pas au clavier." },
  { t: "narration", x: "Le curseur bougea." },
  { t: "narration", x: "Une dernière phrase apparut." },
  { t: "screen", x: "ELLE, NON." },
  { t: "narration", x: "Puis je l'entendis." },
  { t: "narration", x: "Trois coups." },
  { t: "narration", x: "Derrière moi." },
  { t: "knock", x: "Toc." },
  { t: "narration", x: "Une pause." },
  { t: "knock", x: "Toc." },
  { t: "narration", x: "Une pause plus longue." },
  { t: "knock", x: "Toc." },
  { t: "narration", x: "Je me tournai lentement vers la porte de la chambre." },
  { t: "narration", x: "Elle était fermée." },
  { t: "narration", x: "Et sous la porte..." },
  { t: "narration", x: "Une ombre." },
  { t: "narration", x: "Mais cette fois, il n'y avait aucun espace entre le sol et la porte." },
  { t: "narration", x: "Aucun pied." },
  { t: "narration", x: "Aucune jambe." },
  { t: "narration", x: "Juste un visage." },
  { t: "narration", x: "Plaqué contre l'autre côté." },
  { t: "narration", x: "Deux yeux qui me fixaient directement." },
  { t: "narration", x: "Et un sourire." },
  { t: "narration", x: "L'ordinateur écrivit une dernière phrase." },
  { t: "screen", x: "MAINTENANT, TU PEUX REGARDER." }
]
